module.exports = __webpack_public_path__ + "static/media/3.29fc827e.png";